var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-upload",
    {
      attrs: {
        name: "file",
        action: _vm.baseUrl + "/filestream/json/import",
        maxCount: 1,
        showUploadList: false,
        headers: _vm.headers,
        accept: ".json, .json5",
      },
      on: { change: _vm.handleChange },
    },
    [_c("HKLButton", { attrs: { action: "import", color: "darkblue" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }